// extracted by mini-css-extract-plugin
module.exports = {"root":"Outlet_root__34o9g"};